import { detectiveUrl } from '@/env'

const common = {
  switch: {
      1: '啟用',
      0: '停用'
  },
  menu: {
      home: '首頁',
      contact: '聯絡我們',
      marketing: '營銷管理',
      advertise: '廣告',
      video: '視頻中心',
      news: '新聞資訊',
      record: '實時數據',
      deposit: '充值渠道',
      partner: '合作夥伴',
      faq: '常見問題'
  },
  setting: {
      found: '找到了',
      row: '筆',
      noResult: '沒有找到符合的結果',
      pleaseChoose: '請選擇',
      signout: '登出',
      signin: '登入',
      title: '嗨支付後台管理',
      username: '帳號',
      password: '密碼',
      all: '全部',
      saveBtn: '保存',
      cancelBtn: '取消',
      request: '不可為空',
      contactDetailBtn: '反應詳情',
      removeBtn: '移除',
      editBtn: '修改',
      operating: '操作',
      enable: '啟用',
      disable: '停用'
  },
  label: {
      customer: '跑量中商戶數',
      orderSuccess: '訂單成功率（％）',
      min: '平均下發時間（分）',
      question: '問題',
      answer: '答案',
      title: '標題',
      content: '內容',
      email: '電子郵件',
      social: 'QQ/微信',
      name: '名稱',
      type: '類型',
      imageUrl: '封面照',
      videoUrl: '封面影片',
      top: '置頂',
      url: '網址',
      position: '位置',
      sort: '排序',
      click: '點擊次數',
      status: '狀態',
      createTime: '創建時間',
      startTime: '開始時間',
      endTime: '結束時間',
      note: '備註'
  },
  header: {
      recordAddBtn: '新增實時數據',
      faqAddBtn: '新增常見問題',
      depositAddBtn: '新增充值渠道',
      partnerAddBtn: '新增合作夥伴',
      newsAddBtn: '新增新聞',
      videoAddBtn: '新增影片',
      advertiseAddBtn: '新增廣告',
      searchText: '請輸入欲搜尋關鍵字',
      statusText: '狀態',
      startTimeText: '開始時間',
      endTimeText: '結束時間'
  },
  pagination: {
      layout: 'total, sizes, prev, pager, next, jumper',
      pageSizes: [10, 20],
      pageSize: 10,
      pageSizeNoLimit: 1000
  },
  upload: {
      uploadRemoveVideo: '移除影片',
      uploadRemoveImage: '移除照片',
      uploadBtnTextImage: '從電腦中選擇照片',
      uploadBtnTextVideo: '從電腦中選擇影片',
      hintOneImage: '限制上傳 1 張照片，支持 jpg, png, jpeg 格式，不可超過 10MB',
      hintOneVideo: '限制上傳 1 部影片，不可超過 2G',
      videoApi: `${detectiveUrl()}/api/upload/video`,
      imageApi: `${detectiveUrl()}/api/upload/image`,
      imageAccept: 'image/*',
      videoAccept: 'video/*'
  },
  dialog: {
      mini: '350px',
      small: '450px',
      medium: '550px',
      large: '650px',
      xlarge: '750px',
      xxlarge: '850px'
  },
  message: {
      setDefault: '已恢復成自定義',
      setUnlimited: '已設定成永久',
      urlValid: '請輸入完整網址 http:// or https:// + 原網址',
      timeValid: '結束時間不可小於開始時間',
      imgUploading: '照片上傳中...',
      imgUploadSuccess: '照片上傳成功',
      videoUploading: '影片上傳中...',
      videoUploadSuccess: '影片上傳成功',
      switchSuccess: '切換成功',
      warning: '警告',
      confirm: '確定',
      cancel: '取消',
      removeSuccess: '移除成功',
      removeConfirm: '確定要移除嗎？',
      signinSuccess: '登入成功',
      signoutSuccess: '已登出',
      signinRequest: '請先登入管理員',
      saving: '保存中...',
      doing: '操作中...',
      saveSuccess: '保存成功',
      doSuccess: '操作完成'
  }
}

export default common
